export default {
  "settingsTargetSaved": "Target saved",
  "settingsVisual0": "Configure assignments, goals, tasks and sequences for each saved stage.",
  "settingsVisual1": "Define your pipeline stages, colours and outcomes.",
  "settingsVisual2": "Name each stage and choose its colour and outcome.",
  "settingsVisual3": "Colour",
  "settingsVisual4": "Custom colour",
  "settingsVisual5": "stages",
  "settingsVisual6": "Enter stage names to see your pipeline preview.",
  "settingsVisual7": "All changes saved",
  "settingsVisual8": "Organise your sales process into clear stages.",
  "settingsVisual9": "Set a measurable goal for your team.",
  "settingsVisual10": "Save your changes?",
  "settingsVisual11": "All team tasks, including unassigned work.",
  "settingsVisual12": "Only tasks assigned to themselves.",
  "settingsVisual13": "Managers: all team tasks. Salespersons: own tasks only. Unassigned tasks: managers only.",
  "settingsVisual14": "Access and assignment defaults",
  "settingsVisual15": "Unassigned tasks are visible to managers only.",
  "settingsVisual16": "Set assignment defaults and review access by CRM role.",
  "settingsVisual17": "Assignment preview",
  "settingsVisual18": "Illustrative rules only — not live work.",
  "settingsVisual19": "Eligible task creator",
  "settingsVisual20": "Eligible lead owner",
  "settingsVisual21": "Creator is not eligible",
  "settingsVisual22": "Lead owner is not eligible",
  "settingsVisual23": "Staff member",
  "settingsVisual24": "Task access stays the same.",
  "settingsVisual25": "Will have access to all team tasks.",
  "settingsVisual26": "Will only see their own assigned tasks.",
  "settingsVisual27": "{count} staff selected",
  "settingsVisual28": "Active staff",
  "settingsVisual29": "Selection",
  "settingsVisual30": "Department · Job title",
  "settingsVisual31": "Already in sales team",
  "settingsVisual32": "Remove selection",
  "settingsVisual33": "Choose your team",
  "settingsVisual34": "Select staff on the left to review their roles here.",
  "settingsVisual35": "CRM access will be removed",
  "settingsVisual36": "Lead ownership is separate from task assignment.",
  "settingsVisual37": "Work to reassign",
  "settingsVisual38": "No open work to reassign",
  "settingsVisual39": "Completed history stays with this staff member. Only open work can be transferred.",
  "settingsVisual40": "Ownership transfer",
  "settingsVisual41": "Open tasks",
  "settingsVisual42": "Active leads",
  "settingsVisual43": "No open work to transfer in this section.",
  "settingsVisual44": "Ready to remove membership. History is preserved.",
  "settingsVisual45": "Choose destinations for all open work to continue.",
  "settingsVisual46": "Add staff to sales team",
  "settingsVisual47": "Choose existing staff members and assign their CRM role.",
  "settingsVisual48": "Review access and transfer open work before removing membership.",
  "settingsVisual49": "Transfer open tasks and active leads while preserving completed history.",
  "selectALeadToSeeAIInsightsAndSuggestions": "Select a lead to see AI insights and suggestions",
  "aIInsights": "AI Insights",
  "suggestedActions": "Suggested Actions:",
  "confidence": "Confidence:",
  "noActiveInsightsForThisLead": "No active insights for this lead",
  "suggestedNextSteps": "Suggested Next Steps",
  "timeline": "Timeline:",
  "aIEmailAssistant": "AI Email Assistant",
  "tone": "Tone:",
  "professional": "Professional",
  "friendly": "Friendly",
  "formal": "Formal",
  "casual": "Casual",
  "generatedDraft": "Generated Draft:",
  "sendEmail": "Send Email",
  "copyToClipboard": "Copy to Clipboard",
  "briefSummaryOfLeadSJourneyAndStatus": "Brief summary of lead's journey and status",
  "mainTopicsDiscussedSoFar": "Main topics discussed so far",
  "questionsToAskInNextInteraction": "Questions to ask in next interaction",
  "recommendedNextStep": "Recommended next step",
  "thingsToWatchOutForOrLeverage": "Things to watch out for or leverage",
  "aIContactAssistant": "AI Contact Assistant",
  "analyzing": "Analyzing...",
  "insights": "Insights",
  "lastUpdated": "Last updated:",
  "clickGenerateInsightsToGetAIPoweredLeadAnalysis": "Click \"Generate Insights\" to get AI-powered lead analysis",
  "analyzingLeadDataAndGeneratingInsights": "Analyzing lead data and generating insights...",
  "leadSummary": "Lead Summary",
  "keyDiscussionTopics": "Key Discussion Topics",
  "suggestedQuestions": "Suggested Questions",
  "q": "Q",
  "recommendedNextAction": "Recommended Next Action",
  "importantNotes": "Important Notes",
  "failedToLoadLeads": "Failed to load leads",
  "leadsUpdated": "Leads updated",
  "failedToAddLeadsToPipeline": "Failed to add leads to pipeline",
  "allLeads": "All Leads",
  "searchFilterAndManageLeadsAcrossAllPipelines": "Search, filter, and manage leads across all pipelines.",
  "searchLeadsByNameOrEmail": "Search leads by name or email",
  "allPipelines": "All pipelines",
  "noPipelineAssigned": "No pipeline assigned",
  "lead": "Lead",
  "phone": "Phone",
  "source": "Source",
  "pipeline": "Pipeline",
  "stage": "Stage",
  "statusTemp": "Status / Temp",
  "lastActivity": "Last Activity",
  "created": "Created",
  "noLeadsFound": "No leads found.",
  "page": "Page",
  "of": "of",
  "previous": "Previous",
  "next": "Next",
  "leadSSelected": "lead(s) selected",
  "clearSelection": "Clear selection",
  "addToPipeline": "Add to Pipeline",
  "selectAPipelineToMoveTheSelectedLeadsIntoTheFirstStage": "Select a pipeline to move the selected leads into the first stage.",
  "chooseAPipeline": "Choose a pipeline",
  "cancel": "Cancel",
  "confirm": "Confirm",
  "cRMAnalytics": "CRM Analytics",
  "last7Days": "Last 7 days",
  "last30Days": "Last 30 days",
  "last90Days": "Last 90 days",
  "pipelineValue": "Pipeline Value",
  "activeDeals": "Active Deals",
  "winRate": "Win Rate",
  "avgDealSize": "Avg. Deal Size",
  "activeLeads": "Active Leads",
  "conversionRate": "Conversion Rate",
  "target": "Target",
  "failedToLoadCRMSummary": "Failed to load CRM summary.",
  "pipelineDistribution": "Pipeline Distribution",
  "activityTrends": "Activity Trends",
  "leadSourcePerformance": "Lead Source Performance",
  "dealHealthOverview": "Deal Health Overview",
  "healthyActive": "Healthy (Active)",
  "stale14Weeks": "Stale (1-4 weeks)",
  "atRisk30Days": "At Risk (30+ days)",
  "dealsNeedImmediateAttention": "deals need immediate attention",
  "pipelineVelocityAvgDaysInStage": "Pipeline Velocity (Avg. Days in Stage)",
  "avgDays": "Avg. Days",
  "status": "Status",
  "selectAPipelineToViewLeads": "Select a pipeline to view leads.",
  "failedToLoadLeadList": "Failed to load lead list.",
  "loadingLeads": "Loading leads…",
  "name": "Name",
  "company": "Company",
  "contact": "Contact",
  "priority": "Priority",
  "value": "Value",
  "assignedTo": "Assigned To",
  "actions": "Actions",
  "noLeadsFoundForThisPipeline": "No leads found for this pipeline.",
  "loadingPipeline": "Loading pipeline…",
  "unableToDetermineClubContext": "Unable to determine club context.",
  "noCRMPipelinesConfiguredYet": "No CRM pipelines configured yet.",
  "selectAPipelineToViewStages": "Select a pipeline to view stages.",
  "failedToLoadPipelineData": "Failed to load pipeline data.",
  "followUp": "Follow-up:",
  "email": "Email",
  "sMS": "SMS",
  "call": "Call",
  "noLeadsInThisStage": "No leads in this stage",
  "selectSalesTeamMember": "Select sales team member",
  "stageGoalsCanTBeSetOnTheFinalNonTerminalStage": "Stage goals can’t be set on the final non-terminal stage.",
  "taskType": "Task type",
  "taskName": "Task name",
  "taskNote": "Task note",
  "selectActiveSequence": "Select active sequence",
  "remove": "Remove",
  "save": "Save",
  "userAssignments": "User Assignments",
  "stageGoals": "Stage Goals",
  "tasks": "Tasks",
  "sequences": "Sequences",
  "editPipeline": "Edit Pipeline",
  "pipelineName": "Pipeline name",
  "loadingStages": "Loading stages…",
  "addStage": "Add stage",
  "deletePipeline": "Delete pipeline",
  "pipelines": "Pipelines",
  "loadingPipelines": "Loading pipelines…",
  "stages": "Stages",
  "sortOrder": "Sort Order",
  "edit": "Edit",
  "createPipeline": "Create Pipeline",
  "loadingTarget": "Loading target…",
  "label": "Label",
  "annualMemberSignUps": "Annual Member Sign-Ups",
  "goal": "Goal",
  "period": "Period",
  "annual": "Annual",
  "quarterly": "Quarterly",
  "monthly": "Monthly",
  "saveTarget": "Save Target",
  "saved": "Saved.",
  "weeklyActivities": "Weekly Activities",
  "updated": "Updated:",
  "use": "Use",
  "pleaseEnterAnAIPromptFirst": "Please enter an AI prompt first",
  "errorGeneratingContent": "Error generating content",
  "templateName": "Template Name",
  "templateName2": "Template name...",
  "type": "Type",
  "sharing": "Sharing",
  "private": "Private",
  "team": "Team",
  "organization": "Organization",
  "subject": "Subject",
  "emailSubject": "Email subject...",
  "category": "Category",
  "categoryOptional": "Category (optional)...",
  "aIContentAssistant": "AI Content Assistant",
  "eGAFriendlyFollowUpAfterADemo": "e.g., A friendly follow-up after a demo...",
  "generate": "Generate",
  "content": "Content",
  "templateContentUseLeadFirstNameForMergeFields": "Template content... Use {{lead.firstName}} for merge fields",
  "insertField": "Insert field:",
  "leadFirstName": "lead.firstName",
  "leadLastName": "lead.lastName",
  "leadCompany": "lead.company",
  "senderName": "sender.name",
  "saveTemplate": "Save Template",
  "failedToLoadTemplates": "Failed to load templates",
  "errorSavingTemplate": "Error saving template",
  "templateDuplicated": "Template duplicated",
  "errorDuplicatingTemplate": "Error duplicating template",
  "templateArchived": "Template archived",
  "errorArchivingTemplate": "Error archiving template",
  "emailTemplates": "Email Templates",
  "createAndManageReusableTemplates": "Create and manage reusable templates",
  "createTemplate": "Create Template",
  "searchTemplates": "Search templates...",
  "allTypes": "All Types",
  "loadingTemplates": "Loading templates...",
  "noTemplatesFound": "No templates found",
  "createYourFirstTemplate": "Create Your First Template",
  "qualified": "Qualified",
  "contactMade": "Contact Made",
  "tourScheduled": "Tour Scheduled",
  "tourCompleted": "Tour Completed",
  "proposalSent": "Proposal Sent",
  "negotiating": "Negotiating",
  "closedWon": "Closed Won",
  "closedLost": "Closed Lost",
  "low": "Low",
  "medium": "Medium",
  "high": "High",
  "hot": "Hot",
  "setPriority": "Set Priority",
  "setStage": "Set Stage",
  "overview": "Overview",
  "activities": "Activities (",
  "aIAssistant": "AI Assistant",
  "notesTasks": "Notes & Tasks",
  "contactInformation": "Contact Information",
  "logActivity": "Log Activity",
  "convertToMember": "Convert to Member",
  "convertedToMember": "Converted to Member",
  "leadDetails": "Lead Details",
  "referringMember": "Referring Member",
  "membershipInterest": "Membership Interest",
  "timelineDates": "Timeline & Dates",
  "nextFollowUp": "Next Follow-up",
  "tourDate": "Tour Date",
  "notes": "Notes",
  "activityTimeline": "Activity Timeline",
  "noActivitiesRecordedYet": "No activities recorded yet",
  "addNote": "Add Note",
  "noNotesOrTasksYet": "No notes or tasks yet",
  "advancedFilters": "Advanced Filters",
  "filterLeads": "Filter Leads",
  "clearAll": "Clear All",
  "dateAdded": "Date Added",
  "allStaffMembers": "All Staff Members",
  "leadSource": "Lead Source",
  "allSources": "All Sources",
  "pipelineStage": "Pipeline Stage",
  "allStages": "All Stages",
  "allPriorities": "All Priorities",
  "pipelineType": "Pipeline Type",
  "allPipelines2": "All Pipelines",
  "membership": "Membership",
  "corporate": "Corporate",
  "event": "Event",
  "referral": "Referral",
  "estimatedValueRange": "Estimated Value Range",
  "min": "Min",
  "to": "to",
  "max": "Max",
  "sourceEvent": "Source Event",
  "allEvents": "All Events",
  "applyFilters": "Apply Filters",
  "pleaseSelectACountryCode": "Please select a country code.",
  "pleaseEnterAPhoneNumber": "Please enter a phone number.",
  "enterAValidPhoneNumberBetween8And15Digits": "Enter a valid phone number between 8 and 15 digits.",
  "firstName": "First Name *",
  "lastName": "Last Name *",
  "countryCode": "Country code",
  "allCountries": "All countries",
  "phoneNumber": "Phone number",
  "pipeline2": "Pipeline *",
  "selectPipeline": "Select pipeline",
  "stage2": "Stage *",
  "selectStage": "Select stage",
  "source2": "Source *",
  "selectSource": "Select source",
  "website": "Website",
  "advertising": "Advertising",
  "socialMedia": "Social Media",
  "coldOutreach": "Cold Outreach",
  "other": "Other",
  "membershipTypeInterest": "Membership Type Interest",
  "selectType": "Select type",
  "selectPriority": "Select priority",
  "leadValue": "Lead Value",
  "unassigned": "Unassigned",
  "interests": "Interests",
  "addInterestGolfTennisDiningEtc": "Add interest (golf, tennis, dining, etc.)",
  "add": "Add",
  "tags": "Tags",
  "addTag": "Add tag",
  "connections": "Connections",
  "saveLeadFirstToAddConnections": "Save lead first to add connections.",
  "connectionType": "Connection Type",
  "member": "Member",
  "search": "Search",
  "select": "Select",
  "note": "Note",
  "describeTheRelationship": "Describe the relationship",
  "addConnection": "Add Connection",
  "noConnections": "No connections",
  "leadSourceAnalytics": "Lead Source Analytics",
  "refreshData": "Refresh Data",
  "totalSources": "Total Sources",
  "bestConversion": "Best Conversion",
  "topSource": "Top Source",
  "sourcePerformance": "Source Performance",
  "conversionRatesBySource": "Conversion Rates by Source",
  "leadGenerationTrendsLast30Days": "Lead Generation Trends (Last 30 Days)",
  "detailedSourcePerformance": "Detailed Source Performance",
  "totalLeads": "Total Leads",
  "avgValue": "Avg. Value",
  "totalValue": "Total Value",
  "performance": "Performance",
  "interest": "Interest",
  "interestedIn": "Interested in:",
  "projectedValue": "Projected value:",
  "leadToMember": "Lead to member",
  "aNewMemberJoinsTheClub": "A New Member Joins the Club",
  "hasReachedClosedWonWouldYouLikeToOfficiallyCreateTheirMemberProfile": "has reached Closed Won. Would you like to officially create their member profile?",
  "keepInClosedWon": "Keep in Closed Won",
  "followUp2": "Follow-up",
  "noFollowUp": "No follow-up",
  "noActiveLeadsFound": "No active leads found",
  "logActivityFor": "Log Activity for",
  "activityType": "Activity Type",
  "meeting": "Meeting",
  "tour": "Tour",
  "outcome": "Outcome",
  "selectOutcome": "Select outcome",
  "positive": "Positive",
  "neutral": "Neutral",
  "negative": "Negative",
  "noResponse": "No Response",
  "titleSubject": "Title / Subject",
  "description": "Description",
  "sent": "Sent",
  "openRate": "Open Rate",
  "clickRate": "Click Rate",
  "bounced": "Bounced",
  "scheduled": "Scheduled:",
  "created2": "Created:",
  "recipients": "Recipients:",
  "audience": "Audience",
  "schedule": "Schedule",
  "campaignTitle": "Campaign Title",
  "internalCampaignName": "Internal campaign name",
  "campaignType": "Campaign Type",
  "broadcast": "Broadcast",
  "dripCampaign": "Drip Campaign",
  "leadNurture": "Lead Nurture",
  "subjectLine": "Subject Line",
  "emailSubjectLine": "Email subject line",
  "previewText": "Preview Text",
  "textShownInEmailPreview": "Text shown in email preview",
  "fromName": "From Name",
  "replyToEmail": "Reply To Email",
  "repliesYourclubCom": "replies@yourclub.com",
  "emailContent": "Email Content",
  "emailHTMLContent": "Email HTML content...",
  "forPersonalization": "for personalization",
  "targetAudience": "Target Audience",
  "selectedFiltersWillTarget": "Selected filters will target",
  "leads": "leads",
  "leadStages": "Lead Stages",
  "leadSources": "Lead Sources",
  "priorityLevel": "Priority Level",
  "sendTimeOptional": "Send Time (Optional)",
  "leaveBlankToSendImmediately": "Leave blank to send immediately",
  "loadingCampaigns": "Loading campaigns...",
  "marketingCampaigns": "Marketing Campaigns",
  "createAndManageEmailCampaignsForYourLeads": "Create and manage email campaigns for your leads",
  "createCampaign": "Create Campaign",
  "noCampaignsYet": "No campaigns yet",
  "createYourFirstEmailCampaignToStartNurturingLeads": "Create your first email campaign to start nurturing leads",
  "createFirstCampaign": "Create First Campaign",
  "campaignAnalytics": "Campaign Analytics -",
  "opened": "Opened",
  "clicked": "Clicked",
  "close": "Close",
  "failedToLoadProspects": "Failed to load prospects",
  "addedToCRM": "Added to CRM",
  "failedToAddProspectsToCRM": "Failed to add prospects to CRM",
  "undoComplete": "Undo complete",
  "failedToUndoLastImport": "Failed to undo last import",
  "prospects": "Prospects",
  "searchVisitorsAndAddThemToYourCRMPipeline": "Search visitors and add them to your CRM pipeline.",
  "searchProspectsByNameOrEmail": "Search prospects by name or email",
  "undoLastImport": "Undo last import",
  "addToCRM": "Add to CRM",
  "lastVisit": "Last Visit",
  "totalVisits": "Total Visits",
  "noProspectsFoundYet": "No prospects found yet.",
  "salesRep": "Sales Rep",
  "salesManager": "Sales Manager",
  "failedToLoadSalesTeam": "Failed to load sales team",
  "failedToLoadStaff": "Failed to load staff",
  "salesTeamMemberAdded": "Sales team member added",
  "addFailed": "Add failed",
  "updateFailed": "Update failed",
  "memberRemoved": "Member removed",
  "removeFailed": "Remove failed",
  "salesTeam": "Sales Team",
  "controlWhoCanBeAssignedCRMTasks": "Control who can be assigned CRM tasks.",
  "addTeamMember": "Add Team Member",
  "teamMembers": "Team Members",
  "loadingSalesTeam": "Loading sales team...",
  "noSalesTeamMembersYet": "No sales team members yet.",
  "staff": "Staff",
  "jobTitle": "Job Title",
  "role": "Role",
  "searchStaff": "Search Staff",
  "searchByNameEmailTitle": "Search by name, email, title",
  "selectAStaffMember": "Select a staff member",
  "selectAStepToEditItsProperties": "Select a step to edit its properties",
  "onReplyActionS": "On Reply Action(s)",
  "createTask": "Create Task",
  "advanceStage": "Advance Stage",
  "title": "Title",
  "taskTitle": "Task title",
  "normal": "Normal",
  "assignee": "Assignee",
  "movesTheLeadToTheNextStageBySortOrder": "Moves the lead to the next stage by sort order.",
  "emailTemplate": "Email Template",
  "selectTemplate": "Select template...",
  "templateIsRequiredForSendEmailSteps": "Template is required for Send Email steps.",
  "body": "Body",
  "emailBody": "Email body...",
  "previewTemplate": "Preview template",
  "stopOnReply": "Stop on Reply",
  "yes": "Yes",
  "no": "No",
  "sMSTemplate": "SMS Template",
  "selectSMSTemplate": "Select SMS template...",
  "320Characters": "/320 characters",
  "duration": "Duration",
  "1Hour": "1 Hour",
  "1Day": "1 Day",
  "2Days": "2 Days",
  "taskType2": "Task Type",
  "taskTitle2": "Task Title",
  "taskTitle3": "Task title...",
  "dueInMinutes": "Due in minutes",
  "noPropertiesForThisStepType": "No properties for this step type.",
  "stepProperties": "Step Properties",
  "wait": "Wait",
  "followUpCall": "Follow up call",
  "sendSMS": "Send SMS",
  "pleaseEnterASequenceName": "Please enter a sequence name",
  "sequenceSaved": "Sequence saved",
  "sequenceName": "Sequence name...",
  "sequenceSteps": "Sequence Steps",
  "enrollments": "Enrollments",
  "conversion": "Conversion",
  "active": "Active",
  "lastModified": "Last modified:",
  "scope": "Scope:",
  "viewAnalytics": "View Analytics",
  "errorLoadingSequences": "Error loading sequences",
  "errorDuplicatingSequence": "Error duplicating sequence",
  "errorDeletingSequence": "Error deleting sequence",
  "errorLoadingSequenceDetails": "Error loading sequence details",
  "sequenceLibrary": "Sequence Library",
  "createAndManageYourEmailSequences": "Create and manage your email sequences",
  "createSequence": "Create Sequence",
  "searchSequences": "Search sequences...",
  "allStatus": "All Status",
  "archived": "Archived",
  "scope2": "Scope",
  "allScope": "All Scope",
  "loadingSequences": "Loading sequences...",
  "noSequencesFound": "No sequences found",
  "createYourFirstSequence": "Create Your First Sequence",
  "stageChange": "Stage Change",
  "fieldUpdate": "Field Update",
  "timeBased": "Time Based",
  "manual": "Manual",
  "moveStage": "Move Stage",
  "updateField": "Update Field",
  "addTag2": "Add Tag",
  "notifyUser": "Notify User",
  "workflowAutomation": "Workflow Automation",
  "createAutomatedWorkflowsToStreamlineYourSalesProcess": "Create automated workflows to streamline your sales process",
  "createWorkflow": "Create Workflow",
  "deleteWorkflow": "Delete Workflow",
  "areYouSureYouWantToDelete": "Are you sure you want to delete \"",
  "thisActionCannotBeUndone": "\"? This action cannot be undone.",
  "delete": "Delete",
  "trigger": "Trigger:",
  "actions2": "Actions:",
  "executions": "Executions:",
  "noWorkflowsYet": "No Workflows Yet",
  "createYourFirstWorkflowToAutomateYourSalesProcess": "Create your first workflow to automate your sales process",
  "createFirstWorkflow": "Create First Workflow",
  "workflowName": "Workflow Name *",
  "eGNewLeadWelcomeSequence": "e.g., New Lead Welcome Sequence",
  "triggerType": "Trigger Type *",
  "selectTrigger": "Select trigger",
  "describeWhatThisWorkflowDoes": "Describe what this workflow does",
  "addAction": "Add Action",
  "action": "Action",
  "actionType": "Action Type",
  "templateNameOrSubject": "Template name or subject",
  "taskDescription": "Task Description",
  "taskToCreate": "Task to create",
  "targetStage": "Target Stage",
  "noActionsAddedYetClickAddActionToGetStarted": "No actions added yet. Click \"Add Action\" to get started.",
  "activateImmediately": "Activate immediately",
  "assigneesUnavailable": "Assignees unavailable",
  "tasksCanStillBeSavedAsUnassigned": "Tasks can still be saved as Unassigned.",
  "leadRequired": "Lead required",
  "selectALeadBeforeCreatingATask": "Select a lead before creating a task.",
  "dueDateRequired": "Due date required",
  "selectAValidDueDateAndTime": "Select a valid due date and time.",
  "taskRescheduled": "Task rescheduled",
  "taskCreated": "Task created",
  "taskSaveFailed": "Task save failed",
  "planYourNextFollowUp": "Plan your next follow-up.",
  "lead2": "Lead *",
  "searchByNameEmailPhone": "Search by name, email, phone",
  "noResults": "No results.",
  "selectLead": "Select lead",
  "title2": "Title *",
  "dueDateTime": "Due Date & Time *",
  "aM": "AM",
  "pM": "PM",
  "saveTask": "Save Task",
  "taskWorkspace": "Task Workspace",
  "searchTasksLeads": "Search tasks, leads",
  "refresh": "Refresh",
  "newTask": "+ New Task",
  "today": "Today:",
  "overdue": "Overdue:",
  "upcoming": "Upcoming:",
  "completed": "Completed:",
  "allAssignees": "All assignees",
  "loadingTasks": "Loading tasks...",
  "noTasksMatchYourFilters": "No tasks match your filters.",
  "assigned": "Assigned",
  "undoCompletion": "Undo Completion",
  "markComplete": "Mark Complete",
  "taskFocus": "Task Focus",
  "selectATaskToFocusYourNextAction": "Select a task to focus your next action.",
  "relatedLead": "Related Lead",
  "reschedule": "Reschedule",
  "openLead": "Open Lead",
  "allUnassigned": "All / Unassigned",
  "noPhoneNumber": "No phone number",
  "thisLeadDoesNotHaveAPhoneNumberOnFile": "This lead does not have a phone number on file.",
  "cRMPermissionsAreUnavailable": "CRM permissions are unavailable.",
  "newLead": "New Lead",
  "pipeline3": "Pipeline:",
  "assignee2": "Assignee:",
  "pipelineView": "Pipeline View",
  "listView": "List View",
  "failedToLoadCRMPipelines": "Failed to load CRM pipelines.",
  "loadingPipeline2": "Loading pipeline...",
  "loadingInteractions": "Loading interactions...",
  "noInteractionsLoggedYet": "No interactions logged yet.",
  "loggedBy": "Logged by:",
  "active2": "Active (",
  "noActiveSequences": "No active sequences",
  "startSequence": "Start sequence",
  "someSequencesArePausedOrFailed": "Some sequences are paused or failed.",
  "nextRun": "Next run:",
  "failed": "Failed:",
  "stageGoal": "Stage Goal",
  "noStageGoalForThisStage": "No stage goal for this stage",
  "logInteraction": "Log Interaction",
  "interactionType": "Interaction type",
  "selectAType": "Select a type",
  "phoneCall": "Phone Call",
  "direction": "Direction",
  "selectDirection": "Select direction",
  "outbound": "Outbound",
  "inbound": "Inbound",
  "occurredAt": "Occurred at",
  "addAnyRelevantNotes": "Add any relevant notes",
  "saveInteraction": "Save Interaction",
  "meetingNoteUnavailable": "Meeting note unavailable",
  "thisInteractionIsMissingAMeetingLink": "This interaction is missing a meeting link.",
  "weCouldNotLoadThisMeetingNoteItMayHaveBeenDeletedOrYouMayNotHaveAccess": "We could not load this meeting note. It may have been deleted or you may not have access.",
  "sequenceStarted": "Sequence started",
  "failedToStartSequence": "Failed to start sequence",
  "interactionLogged": "Interaction logged",
  "failedToLogInteraction": "Failed to log interaction",
  "leadStageUpdated": "Lead stage updated",
  "failedToUpdateStage": "Failed to update stage",
  "unableToChangePipeline": "Unable to change pipeline",
  "theSelectedPipelineHasNoOpenStagesAvailable": "The selected pipeline has no open stages available.",
  "failedToUpdatePipeline": "Failed to update pipeline",
  "loadingLead": "Loading lead…",
  "leadNotFound": "Lead not found.",
  "backToCRM": "Back to CRM",
  "failedToLoadLead": "Failed to load lead.",
  "noLeadDataAvailable": "No lead data available.",
  "tags2": "Tags:",
  "addTagsSeparatedByCommas": "Add tags separated by commas",
  "startSequence2": "Start Sequence",
  "addTask": "Add Task",
  "viewCompletedTasks": "View completed tasks",
  "noActiveTasksForThisLead": "No active tasks for this lead.",
  "overdue2": "Overdue",
  "today2": "Today",
  "interactions": "Interactions",
  "logInteraction2": "+ Log Interaction",
  "failedToLoadInteractions": "Failed to load interactions.",
  "leadOverview": "Lead Overview",
  "editLead": "Edit lead",
  "loadingConnections": "Loading connections...",
  "source3": "Source:",
  "email2": "Email:",
  "phone2": "Phone:",
  "company2": "Company:",
  "leadValue2": "Lead Value:",
  "assignedTo2": "Assigned To:",
  "stage3": "Stage:",
  "membershipInterest2": "Membership Interest:",
  "interests2": "Interests:",
  "cRMLead": "CRM Lead",
  "sequence": "Sequence",
  "chooseASequence": "Choose a sequence",
  "startTimeOptional": "Start time (optional)",
  "start": "Start",
  "completedTasks": "Completed Tasks",
  "noCompletedTasksForThisLead": "No completed tasks for this lead.",
  "reopen": "Reopen",
  "moveLeadToThisStage": "Move lead to this stage?",
  "generatingSuggestions": "Generating suggestions...",
  "clickRefreshToGetAIPoweredNextSteps": "Click refresh to get AI-powered next steps",
  "generateDraft": "Generate Draft",
  "failedToGenerateAISummaryPleaseTryAgain": "Failed to generate AI summary. Please try again.",
  "justNow": "Just now",
  "selectLeadsToManage": "Select leads to manage",
  "noPipeline": "No pipeline",
  "loading": "Loading…",
  "calls": "Calls",
  "emails": "Emails",
  "meetings": "Meetings",
  "wonDeals": "Won Deals",
  "slow": "Slow",
  "fast": "Fast",
  "converted": "Converted",
  "members": "Members",
  "nA": "N/A",
  "failedToSaveStageAutomation": "Failed to save stage automation",
  "failedToRemoveStageAutomation": "Failed to remove stage automation",
  "failedToSavePipelineStages": "Failed to save pipeline stages",
  "failedToDeletePipeline": "Failed to delete pipeline",
  "userAssignment": "User Assignment",
  "task": "Task",
  "cannotDeleteThisStageBecauseItHasLeadsAssigned": "Cannot delete this stage because it has leads assigned.",
  "closedWonAndClosedLostStagesCannotBeRemoved": "Closed Won and Closed Lost stages cannot be removed.",
  "closedStagesMustBePositionedAtTheEndOfThePipeline": "Closed stages must be positioned at the end of the pipeline.",
  "pipelineMustIncludeExactlyOneClosedWonAndOneClosedLostStage": "Pipeline must include exactly one Closed Won and one Closed Lost stage.",
  "pleaseProvideNamesForAllOpenStages": "Please provide names for all open stages.",
  "cannotDeleteAPipelineThatHasLeadsPleaseMoveOrRemoveLeadsFirst": "Cannot delete a pipeline that has leads. Please move or remove leads first.",
  "pleaseEnsureThereIsExactlyOneClosedWonAndOneClosedLostStage": "Please ensure there is exactly one Closed Won and one Closed Lost stage.",
  "allActiveStagesNeedAName": "All active stages need a name.",
  "areYouSureYouWantToDeleteThisPipeline": "Are you sure you want to delete this pipeline?",
  "defineWhoShouldWorkOnTheseLeads": "Define who should work on these leads",
  "automaticallyMoveLeadsToTheNextStageOnceTheseGoalsAreMet": "Automatically move leads to the next stage once these goals are met",
  "createTasksForYourTeamToComplete": "Create tasks for your team to complete",
  "automaticallySendEmailSequencesToALeadOnceItMovesIntoThisStage": "Automatically send email sequences to a lead once it moves into this stage",
  "terminal": "Terminal",
  "failedToLoadCRMTarget": "Failed to load CRM target",
  "failedToCreatePipeline": "Failed to create pipeline",
  "failedToSaveCRMTarget": "Failed to save CRM target",
  "noPreviewAvailable": "No preview available",
  "pleaseEnterATemplateName": "Please enter a template name",
  "editTemplate": "Edit Template",
  "templateUpdated": "Template updated",
  "templateCreated": "Template created",
  "areYouSureYouWantToDeleteThisTemplate": "Are you sure you want to delete this template?",
  "notSet": "Not set",
  "end": "End",
  "pleaseSelectASource": "Please select a source.",
  "pleaseSelectAPipelineAndStage": "Please select a pipeline and stage.",
  "missingClubContext": "Missing club context.",
  "editLead2": "Edit Lead",
  "addNewLead": "Add New Lead",
  "selectAMembershipType": "Select a membership type",
  "searchLeadsByNameEmailPhone": "Search leads by name, email, phone",
  "searchMembersByNameEmailPhoneMembership": "Search members by name, email, phone, membership #",
  "selectAResult": "Select a result",
  "typeAtLeast2CharactersToSearch": "Type at least 2 characters to search",
  "unnamed": "Unnamed",
  "noEmail": "No email",
  "noContact": "No contact",
  "unknown": "Unknown",
  "noNote": "No note",
  "saving": "Saving…",
  "saveChanges": "Save Changes",
  "createLead": "Create Lead",
  "noActivity": "No activity",
  "yourLead": "your lead",
  "creating": "Creating…",
  "createMember": "Create Member",
  "system": "System",
  "voiceRecognitionIsNotSupportedByYourBrowser": "Voice recognition is not supported by your browser.",
  "failedToLogActivityPleaseTryAgain": "Failed to log activity. Please try again.",
  "pleaseEnterCampaignTitleAndSubject": "Please enter campaign title and subject",
  "editCampaign": "Edit Campaign",
  "createEmailCampaign": "Create Email Campaign",
  "updateCampaign": "Update Campaign",
  "errorSavingCampaignPleaseTryAgain": "Error saving campaign. Please try again.",
  "errorDuplicatingCampaignPleaseTryAgain": "Error duplicating campaign. Please try again.",
  "errorDeletingCampaignPleaseTryAgain": "Error deleting campaign. Please try again.",
  "selectProspectsToAddToCRM": "Select prospects to add to CRM",
  "unknownStaff": "Unknown staff",
  "pleaseTryAgain": "Please try again.",
  "inactive": "Inactive",
  "noPreviewAvailable2": "No preview available.",
  "step": "Step",
  "errorSavingSequence": "Error saving sequence",
  "saving2": "Saving...",
  "areYouSureYouWantToArchiveThisSequence": "Are you sure you want to archive this sequence?",
  "analyticsViewComingSoon": "Analytics view coming soon!",
  "pleaseFillInTheRequiredFields": "Please fill in the required fields",
  "errorSavingWorkflowPleaseTryAgain": "Error saving workflow. Please try again.",
  "paused": "Paused",
  "editWorkflow": "Edit Workflow",
  "createNewWorkflow": "Create New Workflow",
  "updateWorkflow": "Update Workflow",
  "meetingNotes": "Meeting Notes",
  "manualUI": "Manual UI",
  "noDueDate": "No due date",
  "unknownTime": "Unknown time",
  "noSubject": "(No subject)",
  "interaction": "Interaction",
  "failed2": "Failed",
  "anErrorOccurredWhileLoggingTheInteraction": "An error occurred while logging the interaction.",
  "failedToLoadTasks": "Failed to load tasks",
  "updatingLeadPipeline": "Updating lead pipeline",
  "noNotesYet": "No notes yet.",
  "upcoming2": "Upcoming",
  "completed2": "Completed",
  "all": "All",
  "noLeadAssociated": "No lead associated",
  "noDescription": "No description",
  "unnamedLead": "Unnamed lead",
  "teamMember": "Team member",
  "assignedUser": "Assigned user",
  "rescheduleTask": "Reschedule Task",
  "receivedEmail": "Received Email",
  "receivedSMS": "Received SMS",
  "receivedEmailOrSMS": "Received Email or SMS",
  "taskCompleted": "Task Completed",
  "draft": "Draft",
  "cancelled": "Cancelled",
  "pending": "Pending",
  "scheduled2": "Scheduled",
  "skipped": "Skipped",
  "running": "Running",
  "readOnly": "Read only",
  "unableToCompleteThisActionPleaseTryAgain": "Unable to complete this action. Please try again.",
  "taskMovedToDate": "Task moved to {date}.",
  "scheduledForDate": "Scheduled for {date}.",
  "movedCountLeadSToPipeline": "Moved {count} lead(s) to {pipeline}",
  "addedCountProspectSToCRM": "Added {count} prospect(s) to CRM",
  "revertedCountLeadSBackToProspects": "Reverted {count} lead(s) back to prospects",
  "sendEmailStepStepRequiresAnEmailTemplate": "Send Email step {step} requires an email template",
  "deleteName": "Delete {name}?",
  "editName": "Edit {name}",
  "duplicateName": "Duplicate {name}",
  "archiveName": "Archive {name}",
  "selectName": "Select {name}",
  "moveName": "Move {name}",
  "firstName2": "First name",
  "lastName2": "Last name",
  "senderName2": "Sender name",
  "companyName": "Company name",
  "notAuthorised": "Not authorised",
  "youDoNotHavePermissionToPerformThisAction": "You do not have permission to perform this action.",
  "pause": "Pause",
  "resume": "Resume",
  "dragCancelled": "Drag cancelled.",
  "liftedItemAtPositionPositionUseArrowKeysToMoveSpaceToDropOrEscapeToCancel": "Lifted item at position {position}. Use arrow keys to move, Space to drop, or Escape to cancel.",
  "movingToPositionPosition": "Moving to position {position}.",
  "droppedAtPositionPosition": "Dropped at position {position}.",
  "pressSpaceToPickUpAnItemUseArrowKeysToMoveItSpaceToDropOrEscapeToCancel": "Press Space to pick up an item. Use arrow keys to move it, Space to drop, or Escape to cancel.",
  "startDate": "Start date",
  "duplicate": "Duplicate",
  "archive": "Archive",
  "selectAll": "Select all",
  "selectProspect": "Select prospect",
  "noDataAvailable": "No data available",
  "errorGeneratingEmailDraftPleaseTryAgain": "Error generating email draft. Please try again.",
  "open": "Open",
  "countHoursAgo": "{count} hours ago",
  "countDaysAgo": "{count} days ago",
  "generateInsights": "Generate Insights",
  "thisLeadHasAlreadyBeenConverted": "This lead has already been converted.",
  "aMemberWithTheseContactDetailsAlreadyExists": "A member with these contact details already exists.",
  "selectAStageInTheSelectedPipeline": "Select a stage in the selected pipeline.",
  "chooseAnActiveSalesTeamMember": "Choose an active sales team member.",
  "thereIsNoImportToUndo": "There is no import to undo.",
  "taskTypeAndNameAreRequired": "Task type and name are required.",
  "sequenceHasNoStepsAddStepsBeforeEnrollingLeads": "Sequence has no steps. Add steps before enrolling leads.",
  "sequenceIsArchivedActivateItBeforeEnrollingLeads": "Sequence is archived. Activate it before enrolling leads.",
  "theSequenceMustBeActiveBeforeEnrollingLeads": "The sequence must be active before enrolling leads.",
  "sequenceNotFound": "Sequence not found.",
  "pipelineNotFound": "Pipeline not found.",
  "taskNotFound": "Task not found.",
  "checkTheRequiredFieldsAndTryAgain": "Check the required fields and try again.",
  "selectAValidStage": "Select a valid stage.",
  "enterAnAIPrompt": "Enter an AI prompt.",
  "chooseEmailOrSMS": "Choose Email or SMS.",
  "golfVisitorLog": "Golf Visitor Log",
  "racquetVisitorLog": "Racquet Visitor Log",
  "spaVisitorLog": "Spa Visitor Log",
  "fitnessVisitorLog": "Fitness Visitor Log",
  "diningVisitorLog": "Dining Visitor Log",
  "visitorLog": "Visitor Log",
  "settingsLeads": "Leads",
  "settingsRedesign0": "CRM settings",
  "settingsRedesign1": "Manage your sales team, pipelines and targets.",
  "settingsRedesign2": "Sales team",
  "settingsRedesign3": "Add existing staff and give them a CRM role. This does not change their job title or club access.",
  "settingsRedesign4": "Add staff",
  "settingsRedesign5": "Search by staff name",
  "settingsRedesign6": "Role filter",
  "settingsRedesign7": "All roles",
  "settingsRedesign8": "Sales Managers",
  "settingsRedesign9": "Salespersons",
  "settingsRedesign10": "Salesperson",
  "settingsRedesign12": "All club CRM tasks",
  "settingsRedesign13": "Only assigned tasks",
  "settingsRedesign14": "CRM role",
  "settingsRedesign15": "results",
  "settingsRedesign16": "Clear filters",
  "settingsRedesign17": "Retry",
  "settingsRedesign18": "No matching staff.",
  "settingsRedesign19": "Unknown role",
  "settingsRedesign20": "Change CRM role",
  "settingsRedesign21": "This person will gain access to all club CRM tasks.",
  "settingsRedesign22": "This person will only be able to view their assigned tasks.",
  "settingsRedesign23": "Apply role",
  "settingsRedesign24": "Staff actions",
  "settingsRedesign25": "Reassign work",
  "settingsRedesign26": "Remove from sales team",
  "settingsRedesign27": "Add selected staff",
  "settingsRedesign28": "Reassign and remove",
  "settingsRedesign29": "Search staff",
  "settingsRedesign30": "Search name, department or job title",
  "settingsRedesign31": "staff selected",
  "settingsRedesign32": "Already added",
  "settingsRedesign33": "Existing authenticated identity required",
  "settingsRedesign34": "Loading staff…",
  "settingsRedesign35": "open tasks",
  "settingsRedesign36": "active leads",
  "settingsRedesign37": "Loading work…",
  "settingsRedesign38": "Their staff record and completed work history remain. Open work must be transferred before removal.",
  "settingsRedesign39": "Search destination staff",
  "settingsRedesign40": "New task assignee",
  "settingsRedesign41": "New lead owner",
  "settingsRedesign42": "Select destination",
  "settingsRedesign43": "Include active lead ownership",
  "settingsRedesign44": "Completed tasks and closed leads will not be changed.",
  "settingsRedesign45": "Refresh preview",
  "settingsRedesign46": "Select staff to continue.",
  "settingsRedesign47": "Task rules",
  "settingsRedesign48": "Managers see all club CRM tasks. Salespersons see only their own. Unassigned tasks are visible to managers.",
  "settingsRedesign49": "Manage rules",
  "settingsRedesign50": "Save rules",
  "settingsRedesign51": "Task visibility",
  "settingsRedesign52": "Fixed by role",
  "settingsRedesign53": "Assignment defaults",
  "settingsRedesign54": "Default owner of new tasks",
  "settingsRedesign55": "Task creator",
  "settingsRedesign56": "Lead owner",
  "settingsRedesign57": "Fallback manager",
  "settingsRedesign58": "Unassigned — visible to managers",
  "settingsRedesign59": "New tasks use the eligible task creator. Otherwise they remain unassigned.",
  "settingsRedesign60": "New tasks use the eligible lead owner, then the fallback manager. Without either, they remain unassigned.",
  "settingsRedesign61": "Defaults apply to new tasks only. Existing assignments and explicit authorised assignees are preserved. Salespersons can only create tasks for themselves.",
  "settingsRedesign62": "Save changes",
  "settingsRedesign64": "Unsaved changes",
  "settingsRedesign65": "Save your changes before closing?",
  "settingsRedesign66": "Keep editing",
  "settingsRedesign67": "Discard changes",
  "settingsRedesign68": "Targets",
  "settingsRedesign69": "Enter a positive whole-number goal.",
  "settingsRedesign70": "Label is required.",
  "settingsRedesign71": "Edit pipeline",
  "settingsRedesign72": "Create pipeline",
  "settingsRedesign73": "Save pipeline",
  "settingsRedesign74": "Sort order",
  "settingsRedesign75": "Provide unique stage names, a pipeline name and a valid sort order.",
  "settingsRedesign76": "Stage name",
  "settingsRedesign77": "Stage colour",
  "settingsRedesign78": "Stage outcome",
  "settingsRedesign79": "Won",
  "settingsRedesign80": "Lost",
  "settingsRedesign81": "Move stage up",
  "settingsRedesign82": "Move stage down",
  "settingsRedesign83": "Remove stage",
  "settingsRedesign84": "Outcomes with existing records cannot be changed. Move records to a stage with the same outcome before removing it.",
  "settingsRedesign85": "prospects must move before this stage can be removed.",
  "settingsRedesign86": "Destination stage",
  "settingsRedesign87": "Keep stage",
  "settingsRedesign88": "Pipeline preview",
  "settingsRedesign89": "Keep one Won and one Lost stage at the end. Drag stages or use the arrow buttons to reorder.",
  "settingsRedesign90": "Saved",
  "settingsRedesign93": "Your changes are stale. Refresh the preview and review the updated work before confirming.",
  "settingsRedesign94": "This record changed. Close and reopen the editor before trying again.",
  "settingsRedesign95": "Choose a replacement fallback manager in Task rules first.",
  "settingsRedesign96": "Staff eligibility changed. Refresh the staff picker and review your selection.",
  "settingsRedesign97": "Some selected staff are already in the sales team. Refresh and try again.",
  "settingsRedesign98": "Choose an eligible destination for every type of open work.",
  "settingsRedesign99": "Existing records prevent changing this outcome. Keep the outcome to preserve reporting.",
  "settingsRedesign100": "Choose a destination stage in this pipeline with the same outcome.",
  "settingsRedesign101": "CRM permissions are unavailable. Please try again.",
  "settingsStageAutomations": "Stage automations",
  "settingsUnableToLoadSettings": "Unable to load settings.",
  "settingsChangesNotSaved": "Changes not saved",
  "settingsAddCountStaff": "Add {count} staff",
  "settingsReplacementFallbackManager": "Replacement fallback manager",
  "settingsStageAssignmentDefaultsWillAlsoTransferToTheNewLeadOwner": "stage assignment defaults will also transfer to the new lead owner.",
  "settingsUseAssignmentDefault": "Use assignment default",
  "settingsNoTaskAccess": "No task access",
  "settingsNoEligibleStaffAreAvailable": "No eligible staff are available."
}
